import React, { useEffect, useState } from "react";

/**
 * SplashScreen — 1.6s opening animation that stamps the new Eventom mark on
 * every fresh session.  Uses CSS-only strokes so it works instantly with no
 * asset dependency.
 *
 *   [ E-mark bars slide in ]   →   [ lime accent square pops ]
 *              →   [ "eventom" wordmark fades in ]
 */
export default function SplashScreen() {
  const [visible, setVisible] = useState(() => {
    try { return !sessionStorage.getItem("eventom_splashed"); } catch { return true; }
  });

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => {
      setVisible(false);
      try { sessionStorage.setItem("eventom_splashed", "1"); } catch {}
    }, 1750);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible) return null;
  return (
    <div data-testid="splash-screen" className="fixed inset-0 z-[100] bg-bg text-white flex items-center justify-center overflow-hidden"
      style={{ animation: "splash-out 400ms ease 1350ms forwards" }}>
      <div className="relative flex flex-col items-center gap-6">
        {/* Logomark — 3 slanted bars sliding in + lime dot */}
        <div className="relative w-[128px] h-[128px]">
          <span className="splash-bar" style={{ top: "12%", left: "10%", width: "72%", animationDelay: "40ms" }} />
          <span className="splash-bar" style={{ top: "42%", left: "10%", width: "72%", animationDelay: "180ms" }} />
          <span className="splash-bar" style={{ top: "72%", left: "10%", width: "56%", animationDelay: "320ms" }} />
          <span className="splash-dot" style={{ animationDelay: "620ms" }} />
        </div>
        {/* Wordmark */}
        <div className="font-fancy text-4xl tracking-tight opacity-0" style={{ animation: "splash-fade 500ms ease 720ms forwards" }}>eventom</div>
        {/* Sub-line */}
        <div className="text-[10px] font-mono uppercase tracking-[0.35em] opacity-0" style={{ animation: "splash-fade 500ms ease 900ms forwards", color: "#D4FF00" }}>Every event. Every crowd.</div>
      </div>

      <style>{`
        @keyframes splash-bar { 0% { transform: translateX(-120%); opacity: 0; } 100% { transform: translateX(0); opacity: 1; } }
        @keyframes splash-dot { 0% { transform: scale(0); opacity: 0; } 60% { transform: scale(1.4); opacity: 1; } 100% { transform: scale(1); opacity: 1; } }
        @keyframes splash-fade { to { opacity: 1; transform: translateY(0); } from { opacity: 0; transform: translateY(6px); } }
        @keyframes splash-out { to { opacity: 0; pointer-events: none; } }
        .splash-bar { position: absolute; height: 18%; background: #F5F5F7; border-radius: 2px; animation: splash-bar 650ms cubic-bezier(0.22,1,0.36,1) forwards; opacity: 0; will-change: transform, opacity; }
        html[data-theme="light"] .splash-bar { background: #0A0A0F; }
        .splash-dot { position: absolute; right: 12%; bottom: 6%; width: 18%; height: 18%; background: #D4FF00; border-radius: 2px; animation: splash-dot 460ms cubic-bezier(0.34,1.56,0.64,1) forwards; opacity: 0; will-change: transform, opacity; }
        html[data-theme="light"] [data-testid="splash-screen"] { background: #FAFAFA; color: #0A0A0F; }
      `}</style>
    </div>
  );
}
